









































import {Vue, Component} from 'vue-property-decorator';
import {SHOPBY_ACCESSTOKEN} from '@/const/words/cookie';
import {getCookie} from '@/utils/cookieUtils';

const accessToken = getCookie(SHOPBY_ACCESSTOKEN);
@Component({})
export default class ProductOptionImageAddForm extends Vue {
  private callback: any = null;
  private mallNo = 0;
  private optionLength = 0;
  private images: any[] = [];

  private addImage() {
    try {
      const files = Array.from((this.$refs.file as HTMLInputElement).files as FileList);

      files.forEach((file) => {
        let optionNo = 0;
        let order = 1;
        let mainYn = 'N';
        const fileName = file.name.replace(/\.(jpg|jpeg|png|gif|bmp)$/gi, '');
        if (fileName.includes('_')) {
          // 옵션 상세 이미지
          mainYn = 'N';
          optionNo = parseInt(fileName.split('_')[0]);
          order = parseInt(fileName.split('_')[1]);
          if (order > 5) {
            throw window.$t('PRODUCT_OPTION_TIP_MAX_5_REGISTER');
          }
        } else {
          // 옵션 대표 이미지
          mainYn = 'Y';
          optionNo = parseInt(fileName);
        }
        if (Number.isNaN(optionNo) || optionNo === 0 || optionNo > this.optionLength) {
          throw window.$t('PRODUCT_OPTION_TIP_GUIDE_SURE');
        }
        this.uploadFile(file, (data: any) => {
          this.images.push({
            mainYn,
            optionNo,
            order,
            url: data.url,
            name: file.name
          });
        });
      });
    } catch (msg) {
      alert(msg || window.$t('PRODUCT_OPTION_TIP_ERROR_IMG'));
    }
  }
  get imagesName() {
    return this.images.map((item) => item.name).toString();
  }
  private uploadFile(file: any, callback: Function): void {
    if (file.size <= 10485760) {
      const data = new FormData();
      data.append('file', file);
      this.$api.postImages({data, params: {mallNo: Number(this.mallNo)}}).then((res) => {
        callback(res.data);
      });
      // axios({
      //   headers: {
      //     Version: '1.0',
      //     'Content-Type': 'multipart/form-data',
      //     accessToken
      //   },
      //   data,
      //   method: 'post',
      //   url: `${process.env.VUE_APP_API_URL}/images?mallNo=${this.mallNo}`
      // }).then((request: any) => {
      //   callback(request.data);
      // });
    } else {
      alert(window.$t('PRODUCT_OPTION_MAX_10'));
      return;
    }
  }
  mounted() {
    this.mallNo = Number(this.$route.query.mallNo);
    this.callback = this.$route.query.dataCallback;
    this.optionLength = Number(this.$route.query.length);
  }
  save() {
    $(window.opener.location).attr('href', `javascript:window.${this.callback}(${JSON.stringify(this.images)});`);
    window.close();
  }
}
